import React from 'react'
import { Block } from '../../../../crRender'
import { useTranslation } from 'react-i18next'
import "./style.css"
const PageInfo = ({ TotalRows, pageSize, pageIndex }) => {
    const { t } = useTranslation()
    return (
        <div className="pagination">
            <Block isRender={TotalRows} className={"displayed-row-count"}>
                {`${TotalRows ? 1 + pageSize * pageIndex : 0} ${t("to")} ${TotalRows == 0 ? 0 : Math.min(pageSize * (pageIndex + 1), TotalRows)} ${t("row")} ${t("of")} ${TotalRows} ${t("row")}`}
            </Block>
        </div>
    )
}

export default PageInfo